import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios' //追記
import VueAxios from 'vue-axios' //追記
import "bootstrap/dist/css/bootstrap.min.css"
import { createHead } from '@vueuse/head'

const head = createHead()

createApp(App).use(router).use(VueAxios, axios).use(head).mount('#app')
